import React from "react";
import Navbar2 from "../mainnav";
import Footer from "../Footer";
import { Container, Row, Col, Image } from "react-bootstrap";
import "../../Home_css/privacy_policy.css";

import ProfileScreen from "../../../Assets/Dahlia_events/Mobileprofile.webp";
import EditProfileScreen from "../../../Assets/Dahlia_events/delet.webp";

const mobileprofile = () => {
  return (
    <>
      <Navbar2 />

      <section className="PrivacyPolicy">
        <Container className="mt-5">
          <h1 className="text-uppercase text-gray-800 mb-3">
            Remove Home Mobile Profile
          </h1>

          <div className="custom-margin-top">
            <Row className="mb-5">
              <Col>
                <h4 className="mb-3">
                  Dahlia Health values your right to control your data and
                  provides a simple and effective way for you to remove your
                  information from the myDahlia Home app at your discretion.
                </h4>
                <h5>The following provides instructions on how to remove your data (your login, your profile, and your session data) from the myDahlia Home app:</h5>
                <h5 className="mt-4">How to delete your profile:</h5>
              </Col>
            </Row>

            <Row className="align-items-start mb-5">
              <Col md={6} className="mb-4">
                <h6>
                  1. Log into the app, tap the menu icon in the top-right
                  corner, and select <strong>"Edit Profile"</strong>.
                </h6>
                <Image
                  src={ProfileScreen}
                  alt="Profile Menu Screenshot"
                  fluid
                  className="mt-3 shadow-sm"
                />
              </Col>

              <Col md={6} className="mb-4">
                <h6>
                  2. Scroll to the bottom of the Profile screen and tap the{" "}
                  <strong>"Delete"</strong> button.
                </h6>
                <Image
                  src={EditProfileScreen}
                  alt="Delete Profile Screenshot"
                  fluid
                  className="mt-3 shadow-sm"
                />
              </Col>
            </Row>

            
          </div>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default mobileprofile;
